'use strict';

const delay = ms => new Promise(res => setTimeout(res, ms));

const { alertMessage } = require('../common/common');


/**
 * Restart a CSS "shake" animation on the provided element.
 *
 * @param {jQuery} $el - jQuery-wrapped element whose shake animation should be triggered.
 * @returns {void}
 */
const shakeElement = $el => {
  $el.removeClass("cc-shake");
  void $el[0].offsetWidth;
  $el.addClass("cc-shake");
};


const SELECTORS = {
    element: '.js-order-detail',
    refundButton: '.js-refund-action',
    detailButton: '.js-detail-action',
    form: '#returnForm',
    productCard: '.cc-product-card__wrp',
    refundCheckbox: '.js-refund-product-checkbox',
    refundSelectbox: '.js-refund-detail-selects',
    refundSelectboxWrapper: '.cc-form__wrap--selectbox',
    openModalBtn: '.js-return-open-modal',
    confirmReturnModal: '#confirmCreateReturnModal'
};

const MODES = {
    refund: 'refund',
    detail: 'detail'
}

class OrderDetail {
    constructor(element) {
        this.element = $(element);
        this.initEvents();
    }

    initEvents() {
        this.onRefundClick();
        this.onSubmit();
        this.onChange();
        this.onSelectCheckbox();
        this.showReturnCaseAlert();
    }

    /**
     * Handles the click event on the refund button
     */
    onSelectCheckbox() {
        
        $(SELECTORS.refundCheckbox).on('click', function() {
            let uuid = $(this).val();   
            let isChecked = $(this).is(':checked');
            toggleRelatedSelectBoxes($(this), isChecked);
        });
    }

    /**
     * Handles the click event on the refund button
     */
    onRefundClick() {
        $(SELECTORS.refundButton).on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.togglePageMode(MODES.refund);
        });

        $(SELECTORS.detailButton).on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.togglePageMode(MODES.detail);
        });
        
        $(SELECTORS.openModalBtn).on('click', (e) => {
            var $form = $(SELECTORS.form);
            var body = buildBody($form.serializeArray());
            
            let validationError = validateForm(body.formList);

            if (body.formList.length <= 0) {
                e.preventDefault();
                e.stopPropagation();
                
                const firstCheckbox = document.querySelector(SELECTORS.refundCheckbox);
                if (firstCheckbox) {
                firstCheckbox.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                }

                alertMessage($(SELECTORS.form).data('error-no-items-selected'), 'cc-alert--danger');

                shakeElement($(SELECTORS.refundSelectboxWrapper));
                return;
            } else if (validationError) {
                e.preventDefault();
                e.stopPropagation();
                alertMessage($form.data('error-invalid-selects'), 'cc-alert--danger');
                return;
            }
        });
    }

    /**
     * Toggles the page mode between refund and detail
     * @param {string} mode
     */
    togglePageMode(mode) {
        this.element.attr('data-mode', mode);
    }

    /**
     * Handles submit form
     */
    onSubmit() {
        $(SELECTORS.form).on('submit', async function (e) {
            e.preventDefault();
            $.spinner().start();
            var $form = $(this);
            var url = $form.attr('action');
            var body = buildBody($form.serializeArray());

            //VALIDATE FORM
            let validationError = validateForm(body.formList);
            if (validationError) {
                $.spinner().stop();
                $(SELECTORS.confirmReturnModal).modal('hide');
                return;
            }

            //BUILD FORM DATA
            let orderNumber = $(SELECTORS.element).data('orderno');
            let orderEmail = $(SELECTORS.element).data('orderemail');
            var formdata = new FormData();
            formdata.append('orderNumber', orderNumber);
            formdata.append('orderEmail', orderEmail);
            formdata.append('itemsToReturn', JSON.stringify(body.formList));

            // CALL API
            try {

                const response = await fetch(url, {
                    method: 'POST',
                    body: formdata,
                });

                const data = await response.json();

                if (response.status === 200) {
                    if (!data.success) {
                        alertMessage(data.msg, 'cc-alert--danger');
                        /* TODO: MGU: Replace with proper Handling for showing the message 
                           delay only inserted for awaiting the time to reade the message
                        */
                        await delay(3000);
                    } else {
                        alertMessage(data.msg, 'cc-alert--success');
                    }

                    var currentUrl = window.location.href;
                    var newUrl = removeUrlParameter(currentUrl, 'pageMode');
                    if (newUrl.indexOf('&createReturn=true') > -1) {
                        newUrl = newUrl.replace('&createReturn=true', '&createReturn=false');
                    }
                    
                    if (!window.location.href.includes('&returnConfirmed=true')) {
                        window.location.href = `${newUrl}&returnConfirmed=true`;
                    }
                    else {
                        window.location.reload();
                    }

                } else {
                    $.spinner().stop();
                    alertMessage(data.msg, 'cc-alert--danger');
                }

            } catch (error) {
                console.error(error);
                $.spinner().stop();
            }

        });
    }

    /**
     * Handles error form
     */
    onChange() {
        //CHECK FORM ERROR
        $('select').on('change', function () {
            var $select = $(this);
            let id = $select.attr('id')
            if ($select.val() > 0) {
                $('#' + id + '-error').text('');
            }
        })
    }

    showReturnCaseAlert() {
        customAlertMessage($('.js-return-section-anchor'));
    }
}


/**
    HELPERS
*/
function buildBody(array) {

    let orderNumber = $(SELECTORS.element).data('orderno');
    let orderEmail = $(SELECTORS.element).data('orderemail');

    let body = {
        orderNumber: orderNumber,
        orderEmail : orderEmail,
        formList: []
    }

    array.forEach(el => {
        if (el.name.includes('refund-lineItem')) {
            let reason = $(`#refund-${el.value}-reason`).val();
            let quantity = $(`#refund-${el.value}-quantity`).val();
            let position = $(`#refund-${el.value}`).data('position');
            let productid = $(`#refund-${el.value}`).data('productid');
            let uuid =  $(`#refund-${el.value}`).data('uuid');
            let obj = {qtyToReturn: quantity, productId: productid, reasonCode: reason, position: position, uuid: uuid}
            body.formList.push(obj)
        }
    });

    return body;
}

function validateForm(form) {
    let error = false

    form.forEach(el => {
        if (el.reasonCode <= 0) {
            let elem = $('#refund-' + el.uuid + '-reason-error');
            elem.addClass('d-block');
            elem.text(elem.data('missing-error'));
            error = true;
        }
        if (el.qtyToReturn <= 0) {
            let elem = $('#refund-' + el.uuid + '-quantity-error');
            elem.addClass('d-block');
            elem.text(elem.data('missing-error'));
            error = true;
        }
    });

    return error;
}


function removeUrlParameter(url, parameter) {
    // Split the URL into parts
    var urlParts = url.split('?');

    if (urlParts.length >= 2) {
        // Get the parameters part of the URL
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlParts[1].split(/[&;]/g);

        // Create a new parameters array excluding the parameter to remove
        for (var i = pars.length; i-- > 0;) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        // Reconstruct the URL without the parameter
        url = urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
    }
    return url;
}


function customAlertMessage($class) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('returnConfirmed') === 'true') {
        $('.js-return-section-anchor > .cc-alert--success.show.d-none').removeClass('d-none')
        scrollAnimate($class, 120);
    }
}

function scrollAnimate (element, headerHeight) {
    var position = element && element.length ? element.offset().top : 0;
    $('html, body').animate({
        scrollTop: position - headerHeight
    }, 500);
    if (!element) {
        $('.logo-home').focus();
    }
}

function toggleRelatedSelectBoxes($checkbox, isChecked) {
    const $wrapper = $checkbox.closest(SELECTORS.refundSelectboxWrapper);
    const $selectBoxes = $wrapper.find(SELECTORS.refundSelectbox);

    if (isChecked) {
        $selectBoxes.fadeIn(200);
    } else {
        $selectBoxes.fadeOut(200);
        $selectBoxes.find('select').val('0').selectpicker('refresh');
    }
}


module.exports = () => {
    $(SELECTORS.element).each((index, element) => {
        new OrderDetail(element);
    });
};